import { com } from '@eidu/web'
import getResourceUrl from '../../resource/getResourceUrl'
import EntitySnapshot = com.eidu.sharedlib.entity.publish.EntitySnapshot

const fetchVersionSnapshot = async (snapshotResourceKey: string): Promise<EntitySnapshot> => {
  const response = await fetch(getResourceUrl(snapshotResourceKey))
  if (!response.ok) throw new Error(`Failed to fetch snapshot: ${response.status}`)
  return EntitySnapshot.fromJsonString(await response.text())
}

export default fetchVersionSnapshot
